<!-- 定时管理描述表单 -->
<template>
    <div class="handle-box">
        <el-form :inline="true" label-width="100px" :model="handleForm" :rules="rules" ref="handleForm" class="demo-form-inline">
            <el-form-item label="定时分类" prop="timerkind">
                <el-cascader
                    expand-trigger="hover"
                    :disabled="index>1"
                    clearable
                    :options="time_kind"
                    :props="{
                        label: 'label',
                        value: 'id'
                    }"
                    v-model="handleForm.timerkind">
                </el-cascader>
            </el-form-item>
            <el-form-item label="设备类型" prop="devtype">
                <el-select v-model="handleForm.devtype" :disabled="index>1" clearable placeholder="设备类型">
                    <el-option label="风盘" :value="1"></el-option>
                    <el-option label="风柜" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="启用状态" prop="enable">
                <el-select v-model="handleForm.enable" :disabled="index>1" clearable placeholder="设备类型">
                    <el-option label="启用" :value="true"></el-option>
                    <el-option label="禁用" :value="false"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称" prop="timername">
                <el-input v-model="handleForm.timername" :disabled="index>1" clearable placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="说明">
                <el-input v-model="handleForm.description" :disabled="index>1" clearable placeholder="请输入说明"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { timerTypeIds } from '@/utils/array'
export default {
    name:  'CmpTimeDesc',
    props: ["index", "parentData"],
    data() {
        return {
            handleForm: {
				timerkind:'',
				devtype:'',
				timername:'',
				enable:''
			},
            rules: {
                timerkind: [{ required: true, trigger: "change", message: "请选择分类" }],
                devtype: [{ required: true, trigger: "change", message: "请选择设备类型" }],
                timername: [{ required: true, trigger: "blur", message: "请输入名称" }],
                enable: [{ required: true, trigger: "change", message: "请选择启用状态" }],
            }
        };
    },
    computed: {
        ...mapGetters(['timeDesc', "timeKind"]),
        time_kind() {
            if(!this.timeKind.Timerkind) return []
            return JSON.parse(this.timeKind.Timerkind)
        }
    },
    watch: {
        index(newVal, oldVal) {
            if(newVal == 2 && oldVal == 1) {
                // 保存
                this.next()
            }
        },
        parentData(newVal) {
            let timerkind = timerTypeIds(this.time_kind, newVal.Timerkind);
            this.handleForm = Object.assign({}, newVal, {timerkind: timerkind});
        }
    },
    created() {
        if(this.parentData.Timerkind) {
            let timerkind = timerTypeIds(this.time_kind, this.parentData.Timerkind);
            this.parentData.timerkind = timerkind;
        }
        this.handleForm = Object.assign(this.handleForm, this.parentData)
		// console.log(this.parentData)
    },
    methods: {
        next(){
            this.$refs["handleForm"].validate((valid) => {
                if (valid) {
                    this.$store.dispatch("setTimeDesc", this.handleForm)
					// this.$emit("getstate", true);
                    this.$emit("next", true);
                } else {
					// this.$emit("getstate", false);
                    this.$emit("next", false);
                    return false;
                }
            });
        }
    }
}

</script>
<style lang='less' scoped>

</style>